import React from 'react'
import { shortcuts } from '../configs/KeyboardShortcutList'
export const KeyboardShortcuts = () => {

    // console.log(shortcuts)
    // let shortcutList = JSON.parse(shortcuts)
    // console.log(shortcuts)

    return (
        <div className='keyboard-shortcuts'>
            <h3>Keyboard shortcuts</h3>
            <hr />
            <table>
                {
                    Object.entries(shortcuts).map((category, ind) => {
                        return (
                            <tbody key={ind}>
                                <tr>
                                    <th colSpan={2}>{category[0]}</th>
                                </tr>
                                {
                                    Object.entries(category[1]).map((shortcut, index) => {
                                        // console.log(shortcut)
                                        return (
                                            <tr key={index}>
                                                <td>{shortcut[0]}</td>
                                                <td>{shortcut[1]}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        )
                    })
                }
            </table>
        </div>
    )
}
